module.exports = __webpack_public_path__ + "static/media/noeating.cc29f866.png";